module.exports = "/_next/static/media/54ff0506833df6bce807fb295e58db30.svg";